module.exports = __webpack_public_path__ + "img/icon_1574.c234102d.svg";